import { useQuery } from "react-query";


import { getCountries } from "../../../../../MyApi/sb/countries";

import Select from "react-select"
import LoadingSpinner from "../../../../UI/spinner";
import icons from "../../../../../Data/icons";

import classes from "./addCity.module.css";

const AddCity = ({
  setCityName,
  setCountryId,selectedCountry,cityName
  
}) => {
 const {data ,isLoading} = useQuery("getcountries" , getCountries)
const countries = data?.data
  const City = icons.City
  const Earth = icons.Earth
  const handleNameChange = (e) => {
    setCityName(e.target.value);
  };
  const handleCountryChange = (selectedOption) => {
    const countryId = selectedOption ? selectedOption.id :0
    setCountryId(countryId);
  };
  if(isLoading){
    return <LoadingSpinner/>
  }

  return (
    <div className={classes.formCard}>
      <h5 className={classes.headTitle}>معلومات المدينة</h5>

      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">اسم المدينة</label>
          <div className={classes.iconInput}>
            <City />
          </div>
          <input
            type="text"
            value={cityName}
            placeholder="ادخل اسم المدينة"
            onChange={handleNameChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> اختار الدولة</label>
          {!data ? <div>no data avalible</div> :
          <Select
            getOptionValue={(e) => e.id}
            getOptionLabel={(e) => e.name}
            value={selectedCountry}
            options={countries}
            onChange={handleCountryChange}
         
          />}
        </div>
    
     
      </div>
    </div>
  );
};

export default AddCity;
